module.exports = __webpack_public_path__ + "img/dns_step3.e9e1e24a.png";